﻿import { Entity, MicroMClient } from "@mcurros2/microm";
import { ProductosIcon } from "../../Productos/Productos";
import { ClientesProductosDef } from "./ClientesProductosDef";

export const ClientesProductosIcon = ProductosIcon;
export const ClientesProductosHelpText = '* Aquí estaran los Productos que seran asignados en los Servicios';

export class ClientesProductos extends Entity<ClientesProductosDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new ClientesProductosDef(), parentKeys);
        super.Form = import('../../Productos/ProductosForm').then((module) => module.ProductosForm);
        this.Title = "Productos";
        this.HelpText = ClientesProductosHelpText;
        this.Icon = ClientesProductosIcon;
    }
}